import request from '@/utils/axios'
import qs from 'qs'


export function login(params) {
  let postData = qs.stringify(params)
  console.log("postData:" + postData);
  return request({
    method: 'post',
    url: 'api/manager/member/login',
    data: postData
  })
}

export function logout(params) {
  return request({
    url: '/user/logout',
    method: 'get',
    data: params
  })
}

export function getUserInfo(params) {
  return request({
    url: '/user/info/get',
    method: 'get',
    data: params
  })
}

export function getUserList(reqData) {
  return request({
    url: '/user/list/get',
    method: 'get',
    data: reqData
  })
}